<template>
  <svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="11"
      height="11"
      transform="matrix(1 0 -0.34202 0.939693 4.2627 0.66333)"
      fill="currentColor"
    />
  </svg>
</template>
